import React from 'react';
import {observer} from 'mobx-react';
import {ROUTE_NAMES} from "../../../../../core/consts";
import {CompetitorPlayersStatsModule} from "../../../../../modules/competitor-players-stats-module/components/competitor-players-stats-module";
import {Popup} from "../../../../../core/components/misc/dialog/popup";
import classNames from "classnames";
import styles from "../styles/match-event.module.scss";
import {MATCH_EVENTS} from "../match-events-widget.consts";

export const MatchEventModulePlayerStatsPopup = observer(({controller}) => {
  const {state, device} = controller;
  const {selectedAthleteId, isPlayerCardPopupVisible} = state;
  const {isSmallView} = device;
  const onClosePlayerPopup = () => controller.action(MATCH_EVENTS.ACTION_TYPES.onPlayerCardPopupClick, {isVisible: false});

  const popupPlayerProp = {
    className: classNames(styles.popup, {[styles.small_view]: isSmallView}),
    onClose: () => onClosePlayerPopup()
  }

  const playerCardModuleProps = {
    gameId: controller.props.gameId,
    source: ROUTE_NAMES.game,
    selectedAthleteId,
    onClose: () => onClosePlayerPopup()
  }

  return (
    isPlayerCardPopupVisible ? <Popup {...popupPlayerProp}>
      <CompetitorPlayersStatsModule {...playerCardModuleProps}/>
    </Popup> : null
  )
});
